import { put, fork, call, takeEvery, select, all } from 'redux-saga/effects';
import app from '../../app';
import { exchangeCouponCompletion, catchError } from '../../actions';

export function* watchExchangeCoupon() {
  yield takeEvery('EXCHANGE_COUPON', function*() {
    const couponExchange = yield select(
      state => state.activity.couponExchange.exchangeCoupon
    );
    const {
      input: { exchangeCode },
    } = couponExchange;

    let error;
    if (!exchangeCode) {
      error = new Error('请输入兑换码');
    }

    if (error) {
      yield put(catchError(error));
      yield put(exchangeCouponCompletion(error));
      return;
    }

    const options = {
      url: '/api/redeem',
      method: 'POST',
      data: { code: exchangeCode },
    };
    const result = yield call(app.httpFetch, options);
    yield put(exchangeCouponCompletion(result.error, result.data));
  });
}

export default function* couponExchangeSaga() {
  yield all([fork(watchExchangeCoupon)]);
}
